var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgEdit(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.816 2.293a1 1 0 011.414 0l1.415 1.414a1 1 0 010 1.414l-9.11 9.11a.5.5 0 01-.195.12l-3.182 1.06a.5.5 0 01-.632-.632l1.06-3.182a.5.5 0 01.121-.195l9.109-9.11zM15.466 3.5H4.5a1 1 0 00-1 1v15a1 1 0 001 1h15a1 1 0 001-1V8.123l-1.2 1.2V18.8a.5.5 0 01-.5.5H5.2a.5.5 0 01-.5-.5V5.2a.5.5 0 01.5-.5h9.066l1.2-1.2zm4.365-.005a.3.3 0 00-.424 0l-8.839 8.839-.626 1.628a.1.1 0 00.129.13l1.628-.627 8.84-8.839a.3.3 0 000-.424l-.708-.707z"
  })));
}

export default SvgEdit;